export const T = {
  en_GB: {
    noData: "No volatility data available. Ensure the goal has portfolios with forecasts.",
    notEvaluableNoRiskScore:
      "The goal has no risk score yet, so the volatility ceiling cannot be selected.",
    notEvaluableNoSnapshot:
      "No volatility forecast is available for this goal yet. Regenerate the snapshots.",
    notEvaluableMissingAssetData:
      "A portfolio in this goal has no forecast data, so the goal's volatility cannot be measured.",
    noDataPoints: "No data points to display.",
    year1Label: "Year 1 Volatility",
    year1Hint: (date: string) => `${date}, one year after the first deposit`,
    ceilingLabel: "Max Allowed",
    baselineLabel: "Existing Portfolio",
    breachMessage: "The goal's year-1 volatility breaches the risk bounds.",
    decisionSaved: "Saved",
    error: "Error",
    fetchError: "Failed to load volatility data.",
    retry: "Retry",
    coverageWarning: (pct: string) => `${pct}% of this goal's assets have no volatility data`,
    horizon1Y: "1Y",
    horizon5Y: "5Y",
    horizon10Y: "10Y",
    volatility: "Volatility",
    date: "Date",
  },
  nb_NO: {
    noData: "Ingen volatilitetsdata tilgjengelig. Sørg for at målet har porteføljer med prognoser.",
    notEvaluableNoRiskScore:
      "Målet har ingen risikoscore ennå, så volatilitetsgrensen kan ikke velges.",
    notEvaluableNoSnapshot:
      "Ingen volatilitetsprognose er tilgjengelig for dette målet ennå. Generer øyeblikksbildene på nytt.",
    notEvaluableMissingAssetData:
      "En portefølje i dette målet mangler prognosedata, så målets volatilitet kan ikke måles.",
    noDataPoints: "Ingen datapunkter å vise.",
    year1Label: "År 1 volatilitet",
    year1Hint: (date: string) => `${date}, ett år etter første innskudd`,
    ceilingLabel: "Maks tillatt",
    baselineLabel: "Eksisterende portefølje",
    breachMessage: "Målets år-1-volatilitet bryter risikogrensene.",
    decisionSaved: "Lagret",
    error: "Feil",
    fetchError: "Kunne ikke laste volatilitetsdata.",
    retry: "Prøv igjen",
    coverageWarning: (pct: string) =>
      `${pct}% av dette målets eiendeler har ingen volatilitetsdata`,
    horizon1Y: "1 år",
    horizon5Y: "5 år",
    horizon10Y: "10 år",
    volatility: "Volatilitet",
    date: "Dato",
  },
} as const;
